import * as React from 'react';
import { LibraryProperties, ReportMissingDocument } from '../molecules';
import { UserContext } from '../context/userContext';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';

import Box from '@mui/material/Box';
import {
  Autocomplete,
  Card,
  CardContent,
  CardHeader,
  Stack,
  TextField,
} from '@mui/material';
import { Helmet } from 'react-helmet';
import { libraryService } from '../api';
import { LibraryListType } from '../types';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ActionBar } from '../molecules/ActionBar';

const columns: GridColDef[] = [
  {
    field: 'uc_doc_title_per_owner',
    headerName: 'Title',
    flex: 1,
  },
];

export const LibraryPage: React.FC = () => {
  const { loggedIn } = React.useContext(UserContext);
  const [selectedLibrary, setSelectedLibrary] =
    React.useState<LibraryListType>();
  const { libraryTagList = [], getLibrary } = libraryService();
  const paginationModel = { page: 0, pageSize: 20 };

  const rows = getLibrary(selectedLibrary?.slug);

  const handleSelectBundle = (event: any, bundle: LibraryListType | null) => {
    if (bundle?.slug) {
      setSelectedLibrary(bundle);
    }
  };

  return loggedIn ? (
    <>
      <Helmet>
        <title>Libraries</title>
      </Helmet>

      <ActionBar
        title={`Library > ${selectedLibrary?.name || '...'}`}
        actions={<ReportMissingDocument label="Document" />}
      />
      <Box component="main" p={2}>
        <Stack spacing={2} direction="row">
          <Card sx={{ flex: 2, minWidth: 400 }}>
            <CardContent>
              <Stack spacing={2}>
                <Autocomplete
                  id="bundle-tag-selector"
                  sx={{ width: 300 }}
                  autoHighlight
                  options={libraryTagList}
                  filterSelectedOptions
                  onChange={handleSelectBundle}
                  getOptionLabel={({ name }) => name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Library"
                      placeholder="Please select library."
                    />
                  )}
                />
                {/* ISSUE witdth width https://github.com/mui/mui-x/issues/11295 */}
                {!!selectedLibrary && (
                  <DataGrid
                    rows={rows}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      },
                    }}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                  />
                )}
              </Stack>
            </CardContent>
          </Card>
          <Card sx={{ flex: 1, minWidth: 400 }}>
            <Stack>
              <CardHeader
                title={
                  <Stack alignItems="center" direction="row" gap={1}>
                    <InfoOutlinedIcon />
                    Library properties
                  </Stack>
                }
              />

              <CardContent>
                <LibraryProperties slug={selectedLibrary?.slug} />
              </CardContent>
            </Stack>
          </Card>
        </Stack>
      </Box>
    </>
  ) : null;
};
